import { render, staticRenderFns } from "./SubLocation.vue?vue&type=template&id=039cc456"
import script from "./SubLocation.vue?vue&type=script&lang=js"
export * from "./SubLocation.vue?vue&type=script&lang=js"
import style0 from "./SubLocation.vue?vue&type=style&index=0&id=039cc456&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports